/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CmisChangeEventType { 
    changeType: CmisChangeEventType.ChangeTypeEnum;
    changeTime: string;
    any?: Array<object>;
}
export namespace CmisChangeEventType {
    export const ChangeTypeEnum = {
        Created: 'CREATED',
        Updated: 'UPDATED',
        Deleted: 'DELETED',
        Security: 'SECURITY'
    } as const;
    export type ChangeTypeEnum = typeof ChangeTypeEnum[keyof typeof ChangeTypeEnum];
}


